import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";

const Chapter28 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);

    return (
        <>
                 {/* Chapter 28 */}
                <section id="section28" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">{language.chapter28Title}</h2>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter28Paragraph1}

                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter28Paragraph2}
                    </p>

                    <ol className="drivers-handbook-list">
                        <li>{language.chapter28List11}</li>
                        <li>{language.chapter28List12}</li>
                        <li>{language.chapter28List13}</li>
                    </ol>

                    <h3 className="drivers-handbook-subheading">{language.chapter28Subheading1}</h3>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter28Paragraph3}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter28Paragraph4}
                    </p>

                    <ul className="drivers-handbook-list">
                        <li>{language.chapter28List2}</li>
                        <li>{language.chapter28Subheading2}</li>
                        <ul className="drivers-handbook-list">
                            <li>{language. chapter28List31}</li>
                            <li>{language. chapter28List32}</li>
                            <li>{language. chapter28List33}</li>
                            <li>{language. chapter28List34}</li>
                        </ul>
                        <li>{language.chapter28Paragraph5}
                        </li>
                        <li>{language.chapter28Subheading3}</li>
                        <ul className="drivers-handbook-list">
                            <li>{language.chapter28List41}</li>
                            <li>{language.chapter28List42}</li>
                            <li>{language.chapter28List43}</li>
                        </ul>
                        <li>{language.chapter28Subheading4}</li>
                        <ul className="drivers-handbook-list">
                            <li>{language.chapter28List51}</li>
                            <li>{language.chapter28List52}</li>
                            <li>{language.chapter28List53}</li>
                            <li>{language.chapter28List54}</li>
                            <li>{language.chapter28List55}</li>
                        </ul>
                        <li>{language.chapter28Paragraph6}
                        </li>
                        <li>{language.chapter28Paragraph7}
                        </li>
                        <li>{language.chapter28Paragraph8}
                        </li>
                        <li>{language.chapter28Paragraph9}</li>

                    </ul>


                </section>


        </>
    )

}

export default Chapter28;
